import { render, staticRenderFns } from "./vpnui.vue?vue&type=template&id=38b0ae96&scoped=true"
import script from "./vpnui.vue?vue&type=script&lang=js"
export * from "./vpnui.vue?vue&type=script&lang=js"
import style0 from "./vpnui.vue?vue&type=style&index=0&id=38b0ae96&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b0ae96",
  null
  
)

export default component.exports